import { forwardRef } from 'react'

import { useNicheCardModel } from './niche-card.model'
import type { TNicheCardProps } from './niche-card.types'
import { NicheCardView } from './niche-card.view'

export const NicheCard = forwardRef<any, TNicheCardProps>((props, ref) => {
  const nicheCardModel = useNicheCardModel(props)
  return <NicheCardView ref={ref} {...nicheCardModel} {...props} />
})
